<template>
  <b-container class="p-0 px-sm-0">
    <b-card
      header-bg-variant="dark"
      header-border-variant="dark"
      header-text-variant="white"
      header-tag="header"
      border-variant="dark"
      class="main-card"
    >
      <template #header class="card-header px-0">
        <router-link to="/">
          <i class="fas fa-chevron-left"></i> หน้าหลัก
        </router-link>
      </template>
      <b-row>
        <b-col>
          <h5>
            <i class="fas fa-list"></i> จัดการเลขชุด
          </h5>
        </b-col>
        <b-col class="text-right">
          <b-btn variant="success" size="sm" to="/member/numbersets/add">
            <i class="fas fa-plus"></i> สร้างเลขชุด
          </b-btn>
        </b-col>
      </b-row>
      <div class="w-100 mt-2 mb-3 border-bottom"></div>
      <b-row>
        <b-col>
          <b-form-group
            label="จำนวนต่อหน้า"
            label-for="per-page-select"
            label-cols-sm="6"
            label-cols-md="4"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col></b-col>
        <b-col>
          <b-form-group
            label="ค้นหาข้อมูล"
            label-for="filter-input"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-size="sm"
            class="mb-0"
          >
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="ค้นหา"
              size="sm"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        striped
        hover
        :items="items"
        :fields="fields"
        small
        responsive
        show-empty
        emptyText="ไม่มีรายการ"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        class="mt-3"
        id="my-table"
      >
        <template #cell(date)="data">
          {{formatDate(data.item.createdDate)}}
        </template>
        <template #cell(manage)="data">
          <div>
            <b-dropdown
              ref="dropdown"
              id="dropdown-1"
              dropleft
              variant="outline-secondary"
              size="sm"
            >
              <template #button-content>
                <i class="fas fa-cog"></i>
              </template>
              <b-dropdown-item :to="'/member/numbersets/detail/' + data.item.numberSetID">
                <i class="fas fa-info-circle"></i>&nbsp;&nbsp;รายละเอียด
              </b-dropdown-item>
              <b-dropdown-item @click="deleteNumberSet(data.item.numberSetID)">
                <i class="fas fa-trash-alt"></i>&nbsp;&nbsp;ลบ
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <small>จำนวนทั้งหมด {{rows}} รายการ</small>
        </b-col>
        <b-col>
          <div class="overflow-auto">
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
              variant="warning"
              align="right"
              size="sm"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "List",
  data() {
    return {
      filter: null,
      filterOn: [],
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      currentPage: 1,
      fields: [
        {
          key: "numberSetName",
          label: "ชื่อเลขชุด",
          sortable: true
        },
        {
          key: "date",
          label: "วันเวลาที่สร้าง",
          sortable: true,
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: {
            width: "150px"
          }
        },
        {
          key: "manage",
          label: "จัดการ",
          sortable: false,
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: {
            width: "60px"
          }
        }
      ],
      items: []
    };
  },
  mounted() {
    this.getNumberSets();
  },
  methods: {
    formatDate(createdDate) {
      return moment(String(createdDate)).format('DD/MM/YYYY HH:mm');
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    deleteNumberSet(id) {
      this.$bvModal.msgBoxConfirm('ต้องการลบเลขชุดนี้หรือไม่', {
          title: 'ลบเลขชุด',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'ลบ',
          cancelTitle: 'ยกเลิก',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          // console.log(value);
          if(value) {
            axios.post(this.getApiUrl + "/pingpong/deleteNumberSet",
              {
                username: this.getUsername,
                numberSetID: id
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  "token": this.getAccessToken,
                  "username": this.getUsername
                }
              } )
              .then(response => {
                console.log(response);
                if(response.data.statusCode == 200) {
                  this.getNumberSets();
                }
              });
          }
        });
    },
    getNumberSets() {
      axios.post(this.getApiUrl + "/pingpong/getAllNumberSet",
        {
          username: this.getUsername
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        } )
        .then(response => {
          console.log(response);
          if(response.data.statusCode == 200) {
            this.items = response.data.data;
          }
          // else {
          // }
        });
    }
  },
  computed: {
    rows() {
      return this.items.length;
    },
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
};
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.button {
  &-warning {
    background-color: #bd841b;
    border-color: #bd841b;
    color: #ffffff;
  }

  &-outline-warning {
    color: #bd841b;
    border-color: #bd841b;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: #bd841b;
    border-color: #bd841b;
    outline: none;
    box-shadow: none;
    color: #ffffff;
  }
}
</style>